import React from 'react'

function Numbers() {
  return (
<section className="section-3">
  <div className="w-layout-blockcontainer container-3 w-container" />
  <address className="kpis">
    <div className="frame-1952">
      <div className="kpis-2">
        <div className="div-h-stats">
          <div className="h1-40-bold"><span className="h1-40-bold-3">+</span><span className="h1-40-bold-2">1.7 M</span></div>
          <div className="body-l-16-regular">زاروا موقعنا حول العالم</div>
        </div>
        <div className="div-h-stats">
          <div className="h1-40-bold">
            <div className="h1-40-bold"><span className="h1-40-bold-2">569 K</span><span className="h1-40-bold-3">+</span></div>
          </div>
          <div className="body-l-16-regular">مستخدمون جدد انضموا إلينا</div>
        </div>
        <div className="div-h-stats">
          <div className="h1-40-bold">
            <div className="h1-40-bold"><span className="h1-40-bold-2">33487</span><span className="h1-40-bold-3">+</span></div>
          </div>
          <div className="body-l-16-regular">طلاب وثقوا بنا</div>
        </div>
        <div className="div-h-stats">
          <div className="h1-40-bold">
            <div className="h1-40-bold"><span className="h1-40-bold-2">1364</span><span className="h1-40-bold-3">+</span></div>
          </div>
          <div className="body-l-16-regular">خدمات تعليمية مقدمة</div>
        </div>
      </div>
    </div>
  </address>
</section>

  )
}

export default Numbers